export const NOT_TRACKED_CONTENT = '<not tracked>';
export const NESTED_COMPONENT = '<nested component>';
export const ERROR_LOGIN_MESSAGE_QUERY_PARAM = 'errorMessage';
